import { ProductFeatureResponse } from 'services/api/responses/responseTypes';
import type { IProductFeature } from './iProductFeature';

export default class ProductFeature implements IProductFeature {
  name: string;

  isActive: boolean;

  isComingSoon: boolean;

  constructor(data: ProductFeatureResponse) {
    this.name = data.name;
    this.isActive = data.active ?? false;
    this.isComingSoon = data.comingSoon ?? false;
  }
}
